export const GOOGLE_AUTH_LINK = 'https://postits.reachcreativestudio.com/auth/google';
